// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28EaV","colBig":"styles_colBig__1prVc","colSmall":"styles_colSmall__1vU-s","shopifyNameWrapper":"styles_shopifyNameWrapper__355qX"};